<script>
import '@/assets/vendor/bootstrap/js/bootstrap.js';
import {
  getCurrentLanguageFlag,
  getCurrentLanguageName,
  setCurrentLanguage,
  SupportedLanguages
} from "@/assets/js/i18n.js";

export default {
  name: "PageHeader",
  data() {
    return {
      menuIcon: 'bi-list', // 初始图标为列表
      currentTab: '', // 当前选中的菜单项标识
      languages: SupportedLanguages,
      langName: getCurrentLanguageName(),
      langFlag: new URL(getCurrentLanguageFlag(), import.meta.url),
    };
  },
  created() {
    window.addEventListener('scroll', function () {
      const header = document.getElementById('header');
      if (window.scrollY > 50) { // Adjust the threshold as needed
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }
    });
  },
  methods: {
    // 关闭模态框
    closeMenuModal(tab) {
      this.currentTab = tab;
      const modalElement = document.getElementById('menuModal');
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance?.hide();
    },
    showMenu() {
      this.menuIcon = this.menuIcon === 'bi-list' ? 'bi-x' : 'bi-list';

      // 确保模态框DOM已完全渲染
      this.$nextTick(() => {
        const modalElement = document.getElementById('menuModal');

        // 检查是否已有实例，避免重复创建
        let modal = bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
          modal = new bootstrap.Modal(modalElement, {backdrop: 'static'});
        }
        modal.show();

        modalElement.addEventListener('hidden.bs.modal', () => {
          this.menuIcon = 'bi-list';
        }, {once: true});
      });
    },
    setLanguage(lang) {
      setCurrentLanguage(this.$i18n, lang)
      this.langName = getCurrentLanguageName()
      this.langFlag = getCurrentLanguageFlag()
    },
  }
}
</script>

<template>
  <header id="header" class="fixed-top">

    <div class="container d-flex align-items-center justify-content-between">
      <h1 class="logo">
        <a href="#" style="text-decoration: none">
          {{ $t('header.title') }}
        </a>
      </h1>
      <!-- Uncomment below if you prefer to use an image logo -->
      <!--      <a href="index.html" class="logo"><img src="@/assets/img/logo.png" alt="" class="img-fluid"></a>-->

      <nav id="navbar" class="navbar">
        <ul>
          <li><a class="nav-link scrollto active" href="#hero">{{ $t('header.home') }}</a></li>
          <li><a class="nav-link scrollto" href="#features">{{ $t('header.feature') }}</a></li>
          <li><a class="nav-link scrollto" href="#services">{{ $t('header.service') }}</a></li>
          <li><a class="nav-link scrollto" href="#about">{{ $t('header.about') }}</a></li>
          <li><a class="nav-link scrollto" href="#contact">{{ $t('header.contact') }}</a></li>
        </ul>
        <button type="button" class="btn header-item waves-effect ms-3"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        >
          <img id="header-lang-img" v-bind:src="langFlag" v-bind:alt="langName" height="16">
        </button>
        <div class="dropdown-menu dropdown-menu-end" style="background-color: #2a3c57">
          <template v-for="(locale, i) in languages" :key="i">
            <a class="locale-item dropdown-item notify-item" data-lang="en-US"
               @click="setLanguage(locale.language)">
              <img :src="locale.flag" :alt="locale.title" height="12">&nbsp;
              <span class="align-middle">{{ locale.title }}</span>
            </a>
          </template>
        </div>
        <i class="bi bi-list mobile-nav-toggle" ref="menuButton" @click="showMenu"></i>
      </nav>
    </div>
  </header>

  <div
      class="modal fade"
      id="menuModal"
      tabindex="-1"
      aria-labelledby="menuModalLabel"
      aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-end transparent-header"
             style="background-color: transparent !important;">
          <!--          <button
                        type="button"
                        class="btn-close btn-close-white bi mobile-nav-toggle bi-x"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    >
                    </button>-->
          <img src="@/assets/img/close.png" style="width: 24px;height: 24px" class="img-fluid animated" alt=""
               data-bs-dismiss="modal"
               aria-label="Close"/>
        </div>
        <div class="modal-body" style="background-color: #ffffff">
          <div class="list-group-flush">
            <a href="#hero" class="list-group-item list-group-item-action" style="border-bottom: none !important;"
               @click="closeMenuModal('home')"
            >
              <!--              <i class="bi bi-house-door me-2"></i>-->
              <span :class="{ 'active': currentTab === 'home' }">{{ $t('header.home') }}</span>
            </a>
            <a href="#features" class="list-group-item list-group-item-action" style="border-bottom: none !important;"
               @click="closeMenuModal('features')">
              <span :class="{ 'active': currentTab === 'features' }">{{ $t('header.feature') }}</span>
              <!--              <i class="bi bi-star me-2"></i>-->
            </a>
            <a href="#services" class="list-group-item list-group-item-action" style="border-bottom: none !important;"
               @click="closeMenuModal('services')">
              <!--              <i class="bi bi-briefcase me-2"></i>-->
              <span :class="{ 'active': currentTab === 'services' }">{{ $t('header.service') }}</span>
            </a>
            <a href="#about" class="list-group-item list-group-item-action" style="border-bottom: none !important;"
               @click="closeMenuModal('about')"
            >
              <!--              <i class="bi bi-info-circle me-2"></i>-->
              <span :class="{ 'active': currentTab === 'about' }">{{ $t('header.about') }}</span>
            </a>
            <a href="#contact" class="list-group-item list-group-item-action" style="border-bottom: none !important;"
               @click="closeMenuModal('about')">
              <!--              <i class="bi bi-envelope me-2"></i>-->
              <span :class="{ 'active': currentTab === 'contact' }">{{ $t('header.contact') }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.modal-dialog {
  height: 88% !important;
  margin: auto;
  padding: 24px;
  border: none !important;
  box-shadow: none !important;
}

.modal-content {
  height: 88%;
  justify-content: center;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.btn-close-white {
  /* 放大图标（默认尺寸为1em） */
  font-size: 1.25em;
}

.modal-header,
.modal-body {
  height: auto;
  border: none;
  border-radius: 15px;
}

.modal {
  overflow-y: visible !important;
}

.modal-header {
  background-color: transparent !important;
  border-bottom: none !important;
}

.list-group-flush .list-group-item {
  border-bottom: none !important;
}

.list-group-flush .list-group-item:not(:last-child) {
  border-bottom: 1px solid #e5e7eb !important;
}

.list-group-item .active {
  color: #556ee6 !important;
  font-weight: bold; /* 加粗 */
}

.locale-item {
  display: block !important;
}

.locale-item:hover {
  cursor: pointer !important;
  background-color: #37517e !important;
}

</style>